import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('btn-bar ' + _ctx.extaClasses),
        style: _normalizeStyle(_ctx.flexFixedWidth(_ctx.width))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 6));
}
